import { render, staticRenderFns } from "./PaymentProducts.vue?vue&type=template&id=cfcd76dc&"
import script from "./PaymentProducts.vue?vue&type=script&lang=js&"
export * from "./PaymentProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports